import * as types from './types';

export const info = (key, message) => ({
  type: types.INFO,
  payload: {
    key,
    message
  }
});

export const error = (key, message, autoClose=true) => ({
  type: types.ERROR,
  payload: {
    key,
    message,
    autoClose,
  }
});

export const clearInfo = (key) => ({
  type: types.CLEAR_INFO,
  payload: { key }
});

export const clearError = (key) => ({
  type: types.CLEAR_ERROR,
  payload: { key }
});

export const manualClearError = (key) => ({
  type: types.MANUAL_CLEAR_ERROR,
  payload: { key }
});
